module.exports = "https://cdn.thelire.com/ins/resource/ico_coinstore_regularpackages@3x.9c28dcb4ffd4b431321a075d8e2bb20b.png";